import { VariationDetailsPanel } from '../../../sites/components/panel/organisms/VariationDetailsPanel';

interface VariationDrawerContentProps {
  variationId: string;
}

export function VariationDrawerContent({
  variationId,
}: VariationDrawerContentProps) {
  return <VariationDetailsPanel variationId={variationId} />;
}
